import React from 'react';

const Photo = ({ imgUrl, wording }) => {
  return (
    <section className='relative h-[72vh] w-full flex flex-col'>
      {/* Background Image */}
      <img
        src={imgUrl}
        alt='Fitness background'
        className='absolute inset-0 w-full h-full object-cover'
      />

      {/* Overlay */}
      <div className='absolute inset-0 bg-black bg-opacity-60'></div>

      {/* Content */}
      <div className='relative z-10 container px-4 h-full flex flex-col items-start justify-end text-left mb-8 max-w-6xl mx-auto'>
        <div className='border-l-[8px] border-accent pl-4'>
          <h2 className='text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-1'>
            {wording.title.map((title, index) => (
              <div key={index}>{title}</div>
            ))}
          </h2>
          <div className='text-md sm:text-xl md:text-2xl text-gray-200 max-w-2xl'>
            {wording.description.map((description, index) => (
              <p key={index}>{description}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Photo;
